var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4451 1.33428L11.1409 0.62695C11.9633 -0.208983 13.3944 -0.208983 14.2167 0.62695L14.7781 1.19764C15.1893 1.6156 15.4186 2.17021 15.4186 2.75697C15.4186 3.34374 15.1893 3.90638 14.7781 4.31631L14.0823 5.02364L10.4451 1.32624V1.33428ZM9.60698 2.18629L2.40372 9.50875C2.17442 9.74184 2.03209 10.0473 2.00837 10.3768L1.79488 12.7319C1.77116 13.0293 1.87395 13.3187 2.07954 13.5357C2.2693 13.7286 2.51442 13.8331 2.77535 13.8331H2.86233L5.17907 13.6161C5.50326 13.5839 5.80372 13.4392 6.03302 13.2061L13.2363 5.88369L9.59907 2.18629H9.60698ZM17 16.3972C17 16.0676 16.7312 15.7943 16.407 15.7943H0.593023C0.268837 15.7943 0 16.0676 0 16.3972C0 16.7267 0.268837 17 0.593023 17H16.407C16.7312 17 17 16.7267 17 16.3972Z",
    fill: "#49712B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.e21ea262fcd59a48c6dc841aa6221c28.svg";
export { ForwardRef as ReactComponent };